import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import Isvg from "react-inlinesvg";
import { Link } from "react-router";
import Dropzone from "react-dropzone";
import "./mediaCategory.css";

export default class Media extends Component {
  constructor(props) {
    super(props);
  }

  openEditModal = () => {
    const { actions, uid } = this.props;
    actions.setIsEditMediaModalVisible(uid);
  };

  shouldDisplay = () => {
    const { mediasResults, uid } = this.props;
    let shouldDisplay = false;
    mediasResults.forEach(function(item) {
      if (item === uid) {
        shouldDisplay = true;
      }
    });
    return shouldDisplay;
  };

  render() {
    const { apiHost, medias, uid } = this.props;
    if (medias.get(uid) && this.shouldDisplay()) {
      return (
        <div
          className="col-xs-6 col-sm-4 col-md-3 col-lg-2 media-item"
          onClick={this.openEditModal}
        >
          <div className="image-wrapper">
            <img
              src={`${apiHost}/v1/files/${medias.getIn([uid, "fileUID"])}/file`}
            />
            <div className="hover-background">
              <Isvg src="/assets/img/icon_edit.svg" />
            </div>
          </div>
          <p>{medias.getIn([uid, "name"])}</p>
        </div>
      );
    } else {
      return (
        <div
          className="col-xs-6 col-sm-4 col-md-3 col-lg-2 media-item preload"
          onClick={this.openEditModal}
        >
          <div className="image-wrapper row center-xs middle-xs">
            <div className="la-ball-clip-rotate">
              <div />
            </div>
          </div>
          <p>loading...</p>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/browser/mediaCategory/media.react.js